import CustomIconGardener from 'scoreboard/components/custom-icon-gardener'
import { getIcon } from 'scoreboard/components/files/file'

export default CustomIconGardener.extend({
	getIcon(node) {
		return getIcon(node.type, node.fileName, true)
	}
})